import Vue from 'vue'
import Vuetify from 'vuetify/lib';
import App from './App.vue'
// import "material-design-icons-iconfont/dist/material-design-icons.css";
import "vuetify/dist/vuetify.min.css";
import store from './store';
import router from './router'
import VueI18n from 'vue-i18n'
import messages from './i18n/i18n'
import interceptor from './utils/interceptor'
import './assets/css/main.css';

Vue.config.productionTip = false

Vue.use(VueI18n)
Vue.use(Vuetify)

const vuetify = new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    dark: false,
    themes: {
      // light: {
      //   primary: '#4682b4',
      //   secondary: '#b0bec5',
      //   accent: '#8c9eff',
      //   error: '#b71c1c',
      // },
    },
  },
});

const i18n = new VueI18n({
  messages,
  locale: 'en',
  fallbackLocale: 'en'
})

interceptor()

new Vue({
  //created,
  store,
  i18n,
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')

// able to initiate state here, but this request fails without auth
// store.dispatch('getConfig')